import { axios } from '@axios';
import { useQuery, useMutation, MutationOptions } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from '../../lib/react-query';

export const getAllUsers = (params: any): Promise<any> => {
  return axios.get(`/admin/all-users`, { params });
};

export const updateUser = ({ id, updateData }: { id: string; updateData: any }): Promise<any> => {
  return axios.put(`/user/update-user`, updateData, {
    params: { id },
  });
};

export const verifyUser = ( updatedData:{ user_id: string, isVerified: boolean }): Promise<any> => {
  return axios.post(`/admin/verify-user`, updatedData);
};

export const deleteUser = (userId: string): Promise<any> => {
  return axios.delete(`/admin/users/${userId}`);
};

type QueryFnType = typeof getAllUsers;

export const useAllUsersQuery = ({ params, config }: { params: any; config?: QueryConfig<QueryFnType> }) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['allUsersCount', params],
    queryFn: () => getAllUsers(params),
    select: (res: any) => res,
    ...config,
  });
};

type UpdateUserFnType = typeof updateUser;

export const useUpdateUserMutation = (
  options: MutationOptions<Awaited<ReturnType<UpdateUserFnType>>, unknown, Parameters<UpdateUserFnType>[0]>
) => {
  return useMutation<Awaited<ReturnType<UpdateUserFnType>>, unknown, Parameters<UpdateUserFnType>[0]>({
    mutationFn: updateUser,
    ...options,
  });
};

export const useVerifyUserMutation = (
  options: MutationOptions<Awaited<ReturnType<typeof verifyUser>>, unknown, Parameters<typeof verifyUser>[0]>
) => {
  return useMutation<Awaited<ReturnType<typeof verifyUser>>, unknown, Parameters<typeof verifyUser>[0]>({
    mutationFn: verifyUser,
    ...options,
  });
};

type DeleteUserFnType = typeof deleteUser;

export const useDeleteUserMutation = (
  options: MutationOptions<Awaited<ReturnType<DeleteUserFnType>>, unknown, Parameters<DeleteUserFnType>[0]>
) => {
  return useMutation<Awaited<ReturnType<DeleteUserFnType>>, unknown, Parameters<DeleteUserFnType>[0]>({
    mutationFn: deleteUser,
    ...options,
  });
};


export const getProviderHealth = (): Promise<any> => {
  return axios.get(`/admin/provider-health`);
};

export const useProviderHealthQuery = (config?: QueryConfig<typeof getProviderHealth>) => {
  return useQuery<ExtractFnReturnType<typeof getProviderHealth>>({
    queryKey: ["providerHealth"],
    queryFn: () => getProviderHealth(),
    select: (res: any) => res?.data || res,
    refetchInterval: 30000,
    ...config,
  });
};
